<template>
  <div>
      <!-- 查看问卷 -->
      <el-dialog title="查看问卷" :visible.sync="dialogVisibleFrom" width="50%"  @close="closeDialog" 
          center class="questionDialog" >
          <div v-for="(item,index) in questionForm" :key="item.key">
            <div class="box-card" shadow="never" >
                <!-- 标题 -->
                <div class="queTitle">{{(index+1) + '、 '+item.title}}</div>
                <!-- 选项 -->
                <!-- 单选题 和 多选题 -->
                <div v-if="item.type === 1 || item.type === 2">
                  <div v-for="(level,i) in item.level" :key="i" class="queText">
                    <div style="display:flex;align-items: center;">
                      <span style="width:180px">{{ item.level[i]+ '、 '+item.text[i]}} </span>
                      <div style="display:flex;align-items: center;flex:1;margin-left:20px" v-if="item.submitInputText">
                        <span style="color:#333">文本框内容：</span>
                        <span style="flex:1">{{ item.submitInputText }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 填空题 -->
                <div v-if="item.type === 3" class="queText">
                    <span>{{ item.text[0]}} </span>
                </div>
                <!-- 图片选择题 -->
                <div v-if="item.type === 4" class="queText" style="display: flex;">
                  <span>{{ item.level[0] + '、 '}} </span>
                  <img :src="item.picUrl[0]" class="imgItem"  @click="handlePictureCardPreview(item.picUrl[0])"/>
                </div>
                <!-- 图片上传题 -->
                <div v-if="item.type === 5" style="display:flex;width:100%">
                  <div v-for="(pic,n) in item.picUrl" :key="n" class="queText">
                    <img :src="item.picUrl[n]" style="width:80px;height:80px" @click="handlePictureCardPreview(item.picUrl[n])" />
                  </div>
                </div>
            </div>
          </div>
      </el-dialog>

      <!-- 问卷统计 -->
      <el-dialog title="问卷统计" :visible.sync="dialogVisibleData" width="50%"  @close="closeDialog" 
          center class="questionDialog" >
          <div v-for="(item,index) in questionData" :key="item.key">
            <div class="box-card" shadow="never" v-if="item.type === 1 || item.type === 2 || item.type === 4">
                <!-- 标题 -->
                <div class="queTitle" >{{(index+1) + '、 '+item.title}}</div>
                <!-- 选项 -->
                <!-- 单选题 和 多选题 -->
                <div v-if="item.type === 1 || item.type === 2">
                  <div v-for="(level,i) in item.level" :key="i" class="queText">
                    <div style="display:flex;justify-content: space-between;align-items: center;">
                      <div style="width: 190px;">{{ item.level[i]+ '、 '+item.text[i]}} </div>
                      <!-- 单选题 & 含需输入内容 -->
                      <el-button :class="['detail-btn',item.type === 1 && (item.submitInputTextList[level] && item.submitInputTextList[level].length)?'show':'']" type="text" @click="onShowDetail(row,item.submitInputTextList[level])">文本内容详情</el-button>
                      <div class="progress">
                        <span style="width:25%;text-align: right;">{{item.num[i]+'人选择'}}</span>
                        <el-progress v-if="item.total != 0" :text-inside="false" :percentage="Number(((item.num[i]/ item.total)*100).toFixed(0))" style="width:70%"></el-progress>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 图片选择题 -->
                <div v-if="item.type === 4">
                  <div v-for="(pic,n) in item.level" :key="n" class="queText">
                    <div style="display:flex;justify-content: space-between;">
                      <div style="display:flex;width: 30%;">
                      <span>{{ item.level[n] + '、 '}} </span>
                      <img :src="item.picUrl[n]" style="width:80px;height:80px" @click="handlePictureCardPreview(item.picUrl[n])" />
                      </div>
                      <div class="progress">
                        <span style="width:25%;text-align: right;">{{item.num[n]+'人选择'}}</span>
                        <el-progress v-if="item.total != 0" :text-inside="false" :percentage="Number(((item.num[n]/ item.total)*100).toFixed(0))" style="width:70%"></el-progress>
                      </div> 
                    </div>
                  </div>
                </div>
            </div>
          </div>
      </el-dialog>

      <el-dialog :visible.sync="dialogVisibleImg">
        <img width="100%" :src="dialogImageUrl" alt="" v-if="dialogImageUrl">
      </el-dialog>

      <!-- 文本内容详情 -->
      <el-dialog :visible.sync="isShowTextDetail" title="文本内容详情" width="42%" class="text-detail-dialog">
        <el-table :data="textDetailData" stripe
        :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }" :cell-style="{ 'text-align': 'left' }">
        <el-table-column prop="memberNick" label="用户昵称"></el-table-column>
        <el-table-column prop="submitInputText" label="文本内容"></el-table-column>
      </el-table>
      </el-dialog>
  </div>
</template>

<script>
export default {
name: "questionItem",
components: {
},
props: {
  isShowLook: {
    type: Boolean,
    default: false,
  },
  isShowData: {
    type: Boolean,
    default: false,
  },
  queForm:{
    type:Array,
  },
  queData:{
    type:Array,
  }
},
computed: {

},
data() {
    return {
      dialogVisibleFrom: this.isShowLook,
      dialogVisibleData: this.isShowData,
      dialogVisibleImg: false,
      dialogImageUrl:"",
      questionForm:[{
        title:"",
        type:1,//题目类型
        level:[''],//选项ABC
        text:[''],//选项中文
        picUrl:[''],//图片地址
      }],
      questionData:[],

      isShowTextDetail: false,
      textDetailData: [],
    };
},
mounted() {
  if(this.queForm && this.isShowLook){
    this.questionForm=this.queForm
  }else if(this.queData && this.isShowData){
    this.questionData=this.queData
  }
  console.log("this.questionData",this.questionData)
},
methods: {
  handlePictureCardPreview(url) {
    this.dialogImageUrl = url;
    this.dialogVisibleImg = true;
  },
  //关闭弹窗
  closeDialog() {
    this.dialogVisibleFrom = false;
    this.questionForm=[],
    this.questionData=[],
    this.$emit("close");
  },

  onShowDetail(row,list) {
    this.isShowTextDetail = true;
    this.textDetailData = list;
  },

},
};
</script>

<style scoped lang="scss">
.box-card{
  border:1px solid #DCDFE6;
  margin:0 0 10px 0;
  .queTitle{
    padding: 15px 10px;
    background: #e9f1ff;
    font-size: 16px;
    font-weight: bold;
  }
  .queText{
    font-size: 15px;
    padding: 15px;
  }

  .imgItem{
    width: 80px;
    height:80px;
    display: block;
  }
  .progress{
    display: flex;
    width: 50%;
    align-items: center;
    justify-content: space-evenly;
  }
}
</style>
<style lang="scss" scoped>
.text-detail-dialog {
  .el-dialog__body {
    padding: 20px !important;
  }
}
.detail-btn {
    width: 98px;
    display: none;
  }
  .detail-btn.show {
    display: inline-block;
  }
</style>